import React from 'react';
import { Platform } from 'react-native';
import styled from 'styled-components/native';
import PropTypes from 'prop-types';
import Spacer from '../spacer';
import Colors from '../colors';
import Text from '../text';
import useMobile from '../hooks/use-mobile';
const StyledContainer = styled.View`
  flex-direction: row;
`;
const TextGroupContainer = styled.View`
  flex-direction: column;
  align-self: flex-start;
`;
const StyledImage = styled.Image`
  width: 104px;
  height: 104px;
`;
export default function ContentCard(props) {
  const mobile = useMobile();
  const width = mobile ? ContentCard.defaultProps.width : props.width;
  return /*#__PURE__*/React.createElement(StyledContainer, null, Platform.select({
    web: /*#__PURE__*/React.createElement(StyledImage, {
      source: {
        uri: props.imgSrc
      }
    }),
    default: /*#__PURE__*/React.createElement(StyledImage, {
      source: props.imgSrc
    })
  }), /*#__PURE__*/React.createElement(Spacer, {
    size: "f16",
    width: true
  }), /*#__PURE__*/React.createElement(TextGroupContainer, {
    style: {
      width
    }
  }, /*#__PURE__*/React.createElement(Text.BodySmall, {
    weight: "bold",
    color: Colors.gray600
  }, props.header), /*#__PURE__*/React.createElement(Text.BodyExtraSmall, {
    color: Colors.gray500,
    type: "paragraph"
  }, props.body), /*#__PURE__*/React.createElement(Spacer, {
    size: "f16",
    height: true
  }), /*#__PURE__*/React.createElement(Text.BodyBase, {
    color: Colors.purple400,
    onPress: props.link.onPress
  }, props.link.label)));
}
ContentCard.propTypes = {
  imgSrc: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  header: PropTypes.string,
  body: PropTypes.string,
  link: PropTypes.shape({
    label: PropTypes.string,
    onPress: PropTypes.func
  }),
  width: PropTypes.number
};
ContentCard.defaultProps = {
  imgSrc: '',
  header: '',
  body: '',
  link: {
    label: '',
    onPress: () => {}
  },
  width: 208
};
//# sourceMappingURL=content-card.js.map